/**
 * Currency Hook
 * Uses CurrencyCore for business logic
 */

import { useMemo } from 'react';

import { useTagadaContext } from '../providers/TagadaProvider';
import { CurrencyUtils, Currency } from '../../core/utils/currency';

export interface UseCurrencyResult extends Currency {
    format: (amount: number) => string;
}

export function useCurrency(defaultCurrency = 'USD'): UseCurrencyResult {
    const context = useTagadaContext();

    const currency = useMemo(() => {
        return CurrencyUtils.getCurrency(context, defaultCurrency);
    }, [context, defaultCurrency]);

    const format = (amount: number): string => {
        const symbol = currency.symbol || currency.code;
        return `${symbol}${amount.toFixed(currency.decimalPlaces)}`;
    };

    return {
        ...currency,
        format,
    };
}
